// extracted by mini-css-extract-plugin
module.exports = {"main-header-background":"Header_main-header-background__EwW_b","header-content-wrapper":"Header_header-content-wrapper__LZn8h","header-content":"Header_header-content__IUXs5"};